<template>
    <div>
        <el-Form ref="setForm" :model="setForm" label-width="80px" :rules="deptRules" :inline="true"  size="small">
            <el-Form-item label="设置名称" prop="setName">
                <el-input v-model="setForm.setName" style="width: 490px;"></el-input>
            </el-Form-item>
            <el-Form-item label="设置值" prop="setValue">
                <el-input
                        type="textarea"
                        :rows="3"
                        style="width: 490px;"
                        placeholder="请输入设置值"
                        v-model="setForm.setValue">
                </el-input>
            </el-Form-item>
            <el-Form-item label="设置描述" prop="setDesc">
                <el-input
                        type="textarea"
                        :rows="3"
                        style="width: 490px;"
                        placeholder="请输入描述"
                        v-model="setForm.setDesc">
                </el-input>
            </el-Form-item>
            <div style="margin: 30px auto; width: 200px;">
                <el-Form-item>
                    <el-button type="primary" @click="onSubmit">立即提交</el-button>
                    <el-button @click="closeWindow">取消</el-button>
                </el-Form-item>
            </div>

        </el-Form>

    </div>

</template>

<script>
    import {requestSaveBaseSet} from "../../../api";

    export default {
        name: "setEdit",
        props: ['setForm'],
        data() {
            return {
                deptRules: {
                    setName: [
                        { required: true, message: '请输入设置名称', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 2 到 32 个字符', trigger: 'blur' }
                    ],
                    setValue: [
                        { required: true, message: '请输入设置值', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 2 到 500 个字符', trigger: 'blur' }
                    ],
                    setDesc: [
                        { required: true, message: '请输入设置描述', trigger: 'blur' },
                        { min: 1, max: 100, message: '长度在 2 到 2000 个字符', trigger: 'blur' }
                    ],
                },
                allBaseSet: [],
            }
        },
        methods: {
             onSubmit() {
                this.$refs['setForm'].validate((valid) => {
                    if (valid) {
                         requestSaveBaseSet(this.setForm).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.$emit('closeWindow');
                            }else{
                                this.$message.error(res.message);
                            }
                         })
                    }
                });
            },
        },

    }
</script>

<style scoped>

</style>
